/**
 * Форматирует номер телефона вида 79228299999 в +7 922 829-99-99
 */
export const formatPhone = (p: string) => `+${p[0]} ${p.substring(1, 4)} ${p.substring(4, 7)}-${p.substring(7, 9)}-${p.substring(9, 11)}`;
